export default {
    'Sport': '1',
    'Challenge':'2',
    'Standard':'3',
}


// WEBPACK FOOTER //
// ./src/utils/constants/oilratiotype.js